import { Form } from '@pinchenterprisesnpm/friday-ui'
import { Col } from 'styled-bootstrap-grid'
import { GenericTooltip } from 'components/common/GenericTooltip'
import { ColumnType, OffsetType } from '../utils'
import { Label, LabelTooltipWrapper, TooltipWrapper } from './style'
const { Switch } = Form

type TFormSwitchProps = {
  label?: string
  name: string
  value: boolean
  handleChange: (field: string, value: any) => void
  leftLabel?: string
  rightLabel?: string
  labelTooltipMessage?: string
  switchTooltipMessage?: string
  fieldColumns?: ColumnType
  labelColumns?: ColumnType
  fieldOffset?: OffsetType
  isDisabled?: boolean
  testId?: string
}

export const FormSwitch = ({
  label = '',
  name,
  value,
  handleChange,
  leftLabel,
  rightLabel,
  labelTooltipMessage,
  switchTooltipMessage,
  fieldColumns = 9,
  labelColumns = 2,
  fieldOffset = 0,
  isDisabled = false,
  testId,
}: TFormSwitchProps) => {
  return (
    <>
      {label && (
        <Col lg={labelColumns} md={labelColumns}>
          <LabelTooltipWrapper>
            <Label>
              {label}{' '}
              {labelTooltipMessage && (
                <GenericTooltip message={labelTooltipMessage} />
              )}
            </Label>
          </LabelTooltipWrapper>
        </Col>
      )}
      <Col lg={fieldColumns} md={fieldColumns} offset={fieldOffset}>
        <Switch
          isDisabled={isDisabled}
          value={value}
          onChange={values => {
            handleChange(name, values)
          }}
          leftLabel={leftLabel}
          rightLabel={rightLabel}
          data-testid={testId}
        />
        {switchTooltipMessage && (
          <TooltipWrapper>
            <GenericTooltip message={switchTooltipMessage} />
          </TooltipWrapper>
        )}
      </Col>
    </>
  )
}
